import { localizeRoute, type LOCALIZED_PATHS } from '../constants/url-constants';

type AppLocale = keyof typeof LOCALIZED_PATHS;

/**
 * English logical employer profile path (`urlLogical` / Vike filesystem).
 */
export function companyProfileLogicalPath(companyId: string): string {
  const id = String(companyId ?? '').trim();
  return `/company/${encodeURIComponent(id)}`;
}

/**
 * Full public path with locale prefix and localized segment (`/fi/yritys/…`, `/sv/arbetsgivare/…`).
 */
export function companyProfileUrlPath(locale: AppLocale, companyId: string): string {
  const logical = companyProfileLogicalPath(companyId);
  return `/${locale}${localizeRoute(logical, locale)}`;
}
